import { Component, Input, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { fade } from '@core/animations/animations';
import { StatementOfAccountInclusiveSettings } from '@models/businesses';
import { MatterFileType } from '@models/matter';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Select } from '@ngxs/store';
import { BusinessDispatch, BusinessState } from '@state/business';
import { Observable } from 'rxjs';
import { ICON } from '@core/util/icon';

@UntilDestroy()
@Component({
	selector: 'app-set-fee',
	templateUrl: './set-fee.component.html',
	animations: [fade()],
	standalone: false,
})
export class SetFeeComponent implements OnInit {
	public _defaults: StatementOfAccountInclusiveSettings;
	public _fileType: MatterFileType;
	public ICON = ICON;
	public initialAmount: number;
	public initialSetFee: boolean;

	public amount: number;
	public setFee: boolean;

	public saving = false;

	constructor(private businessDispatch: BusinessDispatch) {}

	@Input() set fileType(_fileType: MatterFileType) {
		if (_fileType && this._fileType !== _fileType) {
			this._fileType = _fileType;
			this.setDefaultFeeValues();
		}
	}

	@Select(BusinessState.getStatementOfAccountSetFees)
	statementOfAccountSetFees$: Observable<StatementOfAccountInclusiveSettings>;

	ngOnInit(): void {
		this.statementOfAccountSetFees$
			.pipe(untilDestroyed(this))
			.subscribe((_defaults) => {
				this._defaults = _defaults;
				this.setDefaultFeeValues();
			});
	}

	setDefaultFeeValues(force = false) {
		if (this._fileType)
			switch (this._fileType) {
				case MatterFileType.SALE:
					this.initialAmount = this._defaults?.saleInclusivePrice ?? 0;
					this.initialSetFee = this._defaults?.saleUseInclusivePrice ?? false;
					this.amount = this._defaults?.saleInclusivePrice ?? 0;
					this.setFee = this._defaults?.saleUseInclusivePrice ?? false;
					break;
				case MatterFileType.PURCHASE:
					this.initialAmount = this._defaults?.purchaseInclusivePrice ?? 0;
					this.initialSetFee =
						this._defaults?.purchaseUseInclusivePrice ?? false;
					this.amount = this._defaults?.purchaseInclusivePrice ?? 0;
					this.setFee = this._defaults?.purchaseUseInclusivePrice ?? false;
					break;
				case MatterFileType.REFINANCE:
					this.initialAmount = this._defaults?.refinanceInclusivePrice ?? 0;
					this.initialSetFee =
						this._defaults?.refinanceUseInclusivePrice ?? false;
					this.amount = this._defaults?.refinanceInclusivePrice ?? 0;
					this.setFee = this._defaults?.refinanceUseInclusivePrice ?? false;
					break;
			}
	}

	_onSubmit(form: NgForm) {
		if (form.valid) {
			this.saving = true;
			switch (this._fileType) {
				case MatterFileType.SALE:
					this.businessDispatch.UpdateStatementOfAccountSetInclsivePrices({
						saleUseInclusivePrice: this.setFee,
						saleInclusivePrice: this.amount,
					});
					break;
				case MatterFileType.PURCHASE:
					this.businessDispatch.UpdateStatementOfAccountSetInclsivePrices({
						purchaseUseInclusivePrice: this.setFee,
						purchaseInclusivePrice: this.amount,
					});
					break;
				case MatterFileType.REFINANCE:
					this.businessDispatch.UpdateStatementOfAccountSetInclsivePrices({
						refinanceUseInclusivePrice: this.setFee,
						refinanceInclusivePrice: this.amount,
					});
					break;
			}
		}
		this.saving = false;
	}
}
